module.exports = __webpack_public_path__ + "static/media/cnn.com_2016_10_07_politics_donald-trump-women-vulgar_index.html_plot.807cf695.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/storySparklines/cnn.com_2016_10_07_politics_donald-trump-women-vulgar_index.html_plot.png
// module id = 379
// module chunks = 0